module.exports = __webpack_public_path__ + "static/media/delete.03b76aa6.svg";